"use strict";

var defaultWrapCharge = require('./defaultWrapCharge');

var defaultEnvelopeWrapCharge = require('./defaultEnvelopeWrapCharge');

var linerWrapCharge = require('./linerWrapCharge');

var none = require('./none');

var letterpressDoubleThickFeeEnclosure = require('./letterpressDoubleThickFeeEnclosure');

var letterpressDoubleThickFeeInvitation = require('./letterpressDoubleThickInvitationFee');

module.exports = {
  defaultWrapCharge: defaultWrapCharge,
  defaultEnvelopeWrapCharge: defaultEnvelopeWrapCharge,
  linerWrapCharge: linerWrapCharge,
  none: none,
  letterpressDoubleThickFeeEnclosure: letterpressDoubleThickFeeEnclosure,
  letterpressDoubleThickFeeInvitation: letterpressDoubleThickFeeInvitation
};